import React from 'react'
import { SvgIcon } from '@mui/material'

export const SendFieldTrashIcon = props => (
  <SvgIcon
    viewBox="0 0 34 34"
    sx={{ width: '34px', height: '34px' }}
    {...props}
  >
    <path
      d="M14.6 24.2a1.2 1.2 0 0 0 1.2-1.2v-7.2a1.2 1.2 0 1 0-2.4 0V23a1.2 1.2 0 0 0 1.2 1.2Zm12-14.4h-4.8V8.6A3.6 3.6 0 0 0 18.2 5h-2.4a3.6 3.6 0 0 0-3.6 3.6v1.2H7.4a1.2 1.2 0 1 0 0 2.4h1.2v13.2a3.6 3.6 0 0 0 3.6 3.6h9.6a3.6 3.6 0 0 0 3.6-3.6V12.2h1.2a1.2 1.2 0 1 0 0-2.4Zm-12-1.2a1.2 1.2 0 0 1 1.2-1.2h2.4a1.2 1.2 0 0 1 1.2 1.2v1.2h-4.8V8.6ZM23 25.4a1.2 1.2 0 0 1-1.2 1.2h-9.6a1.2 1.2 0 0 1-1.2-1.2V12.2h12v13.2Zm-3.6-1.2a1.2 1.2 0 0 0 1.2-1.2v-7.2a1.2 1.2 0 1 0-2.4 0V23a1.2 1.2 0 0 0 1.2 1.2Z"
      fill="#E6494F"
    />
  </SvgIcon>
)
